import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/config/routes'
import {routerInterceptor} from './interceptor'

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  routes
})

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
}

routerInterceptor(router)



// WEBPACK FOOTER //
// ./src/router/index.js